module.exports = __webpack_public_path__ + "img/64_15.22902b62.png";